import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import { observable, autorun, action, toJS } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import userSettings from './UserSettings';
import SpectrumPicker from './SpectrumPicker';
import onClickOutside from 'react-onclickoutside';

@onClickOutside
@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class Picker  extends Component  {

  @observable trans = { };
  @observable colors = ['94a4a5','54a76b','31568b','7b549a','7b549a','f77ba6','f9d57e','85e9f2','48c0c0','000000','737469','648d09','d93208','3d126f','f73683','f6c31a','89d2f2','5dd994','338d8d','ffffff'];
  @observable userColors = ['74a4a5','24a76b'];
  @observable showSpectrumPicker = false;
  @observable isPipetteMode = false; 

  constructor(props) {

    super(props)

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;

    let scope = this;

    this.userColors = userSettings.getColors;

  }

  handleClickOutside = (evt) => {

    if ( this.isPipetteMode ) return;
    this.props.onClickOutside();
  }


  choiceColor(val){

    this.props.onChoiceColor(val);
  }

  showPickArea(){
    if ( this.props.bodyMode )
    {
      this.props.showPickArea();
    }
    else
    {
      this.showSpectrumPicker = !this.showSpectrumPicker;
    }




  }

  closePickArea(){

    this.showSpectrumPicker = false;
  }

  addColor(color){

    //this.userColors.push(color);
    this.showSpectrumPicker = false;

    userSettings.addColor(color);

  }

  render() {

    const t = this.t;
    const {colors,userColors} = this;

    return (
      <div className={"Picker " + (this.props.bodyMode ? 'PickerBodyMode' : 'TipBox' )}>
        <span className="Picker-title">Basic Colors</span>
        <ul className="Picker-color-list">
          {
            _.map(colors,(val,key)=>{
              return(
                <li onClick={ () => { this.choiceColor(val) } } key={key} style={{'background':'#'+val}}></li>
              )
            })
          }
        </ul>
        <span className="Picker-title">Your Colors</span>
        <ul className="Picker-color-list">
          {
            _.map(userColors,(val,key)=>{
              return(
                <li onClick={ () => { this.choiceColor(val) } } key={key} style={{'background':'#'+val}}></li>
              )
            })
          }
        </ul>
        <span className="Picker-button-plus" onClick={ ()=> { this.showPickArea() }}>+</span>
        {
          this.showSpectrumPicker
          &&
          <div className="TipBox">
            <SpectrumPicker
              dictionaryStorage={this.props.dictionaryStorage}
              addColor={ (color)=> { this.addColor(color) } }
              closePickArea = { ()=> { this.closePickArea() } }
              disablePickerMode = { ()=> { this.isPipetteMode = false} }
              enablePickerMode = { ()=> { this.isPipetteMode = true} }
            ></SpectrumPicker>
          </div>
        }
      </div>
    );
  }
}


